import React from 'react';
import Particles from 'react-particles-js';
import './blog.css'

const Blogs = () => {
    return (
        <div className='blog'>
            <p className='text-4xl text-center'>Comming soon!!!</p>
            <Particles
                params={{
                    particles: {
                        number: {
                            value: 400,
                            density: {
                                enable: true,
                                value_area: 1000,
                            }
                        },
                    },
                }}
            />

        </div>
    );
};

export default Blogs;